import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import 'firebase/messaging';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import { store, persistor } from './redux/store';
import routes, { renderRoutes } from './routes';
import ThemeConfig from './theme';
import firebase from './firebase';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import GoogleAnalytics from './components/GoogleAnalytics';
import NotistackProvider from './components/NotistackProvider';
import JwtProvider from './components/authentication/JwtProvider';
import ShowToaster from './components/ShowToaster';
import { setEndDate, setStartDate } from './redux/slices/localSettings';

// ----------------------------------------------------------------------


export default function App() {
  const [notificationPermission, setNotificationPermission] = useState(false);
  const [notificationInformation, setNotificationInformation] = useState(null);
  const [isOpen, setIsOpen] = useState(false);


  useEffect(() => {
    const startDate = new Date();
    startDate.setDate(new Date().getDate() - 30);
    setStartDate(startDate);
    const endDate = new Date();
    setEndDate(endDate);
  }, []);
  // ----------------------------------------------------------------------

  useEffect(() => {
    if (notificationPermission) {
      getMessaging();
    } else {
      requestPermission();
    }
  }, []);

  const getMessaging = () => {
    const msg = firebase.messaging();
    msg.getToken().then((data: any) => {
      localStorage.setItem('deviceToken', data);
      // console.warn('token', data);
    });
    msg.onMessage((payload) => {
      // console.log('Message received. ');
      if (isOpen) {
        setNotificationInformation(null);
        setIsOpen(false);
      }
      setNotificationInformation(payload);
      setIsOpen(true);
    });
  };

  const requestPermission = () => {
    console.log('Requesting permission...');
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          setNotificationPermission(true);
          getMessaging();
          console.log('Notification permission granted.');
        } else {
          setNotificationPermission(false);
          console.log('Notification permission denied.');
        }
      });
    } else {
      console.log('Notification API not supported.');
      // throwSnackBar(translate('global.notifications.not.supported'), 'error');
    }
  };


  return (
    <>
      <HelmetProvider>
        <ReduxProvider store={store}>
          <PersistGate loading={<LoadingScreen />} persistor={persistor}>
            <ThemeConfig>
              <RtlLayout>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <NotistackProvider>
                    <BrowserRouter>
                      <JwtProvider>
                        {/* <Settings /> */}
                        <ShowToaster
                          notificationInformation={notificationInformation}
                          isOpen={isOpen}
                          setIsOpen={setIsOpen}
                        />
                        <ScrollToTop />
                        <GoogleAnalytics />
                        {renderRoutes(routes)}
                      </JwtProvider>
                    </BrowserRouter>
                  </NotistackProvider>
                </LocalizationProvider>
              </RtlLayout>
            </ThemeConfig>
          </PersistGate>
        </ReduxProvider>
      </HelmetProvider>
    </>
  );
}
